// LS - Local Storage
export const LS_ACCESS_TOKEN_KEY = "access-token";
export const LS_REFRESH_TOKEN_KEY = "refresh-token";

export const LS_CHAT_TOKEN_KEY = "chat-token";
export const LS_CHAT_REFRESH_TOKEN_KEY = "chat-refresh-token";
